export default __webpack_public_path__ + "media/images/icons/truck-solid-b128d2fc89e8f85c19a5b55af3785b11.svg";